<template>
  <div class="content-message">
    <div class="title">票务号入驻</div>
    <div class="flex">
      <div class="official">
        <div class="official-top">
          <div class="top-button" @click="toPay(1)">+ 添加票务号</div>
          <div class="top-message" @click="set(1)">批量设置指派规则</div>
        </div>
        <div class="official-div" v-for=" index of canAuthTicketNum">
          <div class="message">
            <el-checkbox v-model="checked"></el-checkbox>
            <img src="@/assets/img/icon_header_default.png" alt="">
            <div class="message-name">
              <div class="name">未绑定</div>
            </div>
          </div>
          <div class="official-add" @click="bindingTicket(1)">
            绑定票务号
          </div>
        </div>
        <el-checkbox-group v-model="checkedUserList" @change="change"  v-for="(item,index) in list" :key="index">
        <div class="official-div">
          <div class="message">
            <el-checkbox :label="index" :key="index"></el-checkbox>
            <img :src="item.imgUrl?item.imgUrl:require('@/assets/img/icon_header_default.png')" alt="">
            <div class="message-name">
            <div style="display: flex">
              <div class="name">{{ item.sellerName }}</div>
              <div class="status" v-if="item.status == 1">在线</div>
              <div class="status" style="color: #FF4F76;background: #FFF1F4;" v-if="item.status == 2">离线</div>
              <div class="status" style="color: #FF4F76;background: #FFF1F4;" v-if="item.status == 3">过期</div>
              <div class="status" style="color: #FF4F76;background: #FFF1F4;" v-if="item.status == 0">禁用</div>
            </div>
              <!--              判断是否小于30天即将过期-->
              <div class="name" :class="Date.parse(item.expirationTime) - new Date().getTime() < 1000 * 3600 * 24 * 30?'active':''">{{ item.expirationTime }}到期<div style="color: #FF8622; " v-if="Date.parse(item.expirationTime) - new Date().getTime() < 1000 * 3600 * 24 * 30 && Date.parse(item.expirationTime) - new Date().getTime() > 0">（即将到期）</div><div style="color: red; " v-if="Date.parse(item.expirationTime) - new Date().getTime() < 0">（已到期）</div></div>
            </div>
          </div>
          <div class="button">
            <div class="official-add" @click="toPay(2,item.id)">
              续费
            </div>
            <div class="official-add" @click="bindingTicket(2,item.sellerUuid)">
              换绑
            </div>
            <div class="button-look" @click="set(0,item)">设置指派规则</div>
            <div class="button-look" style="margin-right: 0" @click="getDetail(item.sellerUuid)">详情</div>
          </div>
        </div>
        </el-checkbox-group>
        <el-pagination
          v-if="list.total > 0"
          background
          class="align-right"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="list.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="list.total">
        </el-pagination>
      </div>
      <div class="notice-box">
        <div class="auth-title">注意事项</div>
        <div class="auth-tip">
          <div class="part-box">
            <div class="part-circle"></div>
            <div class="part-content">如遇在使用系统时遇到问题或有疑问，请添加客服微信咨询。</div>
          </div>
        </div>
        <div class="qrcode-box">
          <div class="qrcode-div" v-for="(item,index) in imageList" :key="index">
            <img class="qrcode-img" :src="item" alt="">
<!--            <div class="nickname">守兔票务-雪糕</div>-->
          </div>
        </div>
      </div>
    </div>
    <!--    绑定公众号-->
    <el-dialog
      title="绑定票务号"
      :visible.sync="addOfficial"
      width="30%"
      :before-close="addClose">
      <div v-if="reminder !=''" style="text-align: center">{{reminder}}</div>
      <div class="add-message" v-else>
        <div class="add-message-img">
          <img :src="qrcodeImg" alt="">
        </div>
        <div class="qrcode-text">请使用微信扫码关注票务公众号，进行授权绑定</div>
        <div class="qrcode-button" @click="refreshQrcode">刷新</div>
      </div>
    </el-dialog>
    <!--    指派规则-->
    <el-dialog
      title="指派规则"
      :visible.sync="setShow"
      width="30%"
      :before-close="spreadClose">
      <div class="set-message">
        <el-checkbox-group v-model="checkedRuleList" @change="changeRule" v-for="(item,index) in rulesList" :key="index">
          <div class="set-message-item" >
            <el-checkbox :label="item.id.toString()" :key="item.id.toString()"></el-checkbox>
            <el-popover
            placement="top-start"
            width="200"
            trigger="hover"
            :content="item.ruleText">
            <div class="set-message-text" slot="reference">{{ item.ruleName }}</div>
          </el-popover>
        </div>
        </el-checkbox-group>
      </div>
      <div v-if="rulesList.length == 0"> 暂无指派规则。请先创建规则</div>
      <div class="button-ed">
        <div class="button-cancel" @click="setShow = false">取消</div>
        <div class="button-confirm" @click="goAddRule()" v-if="rulesList.length == 0">去设置</div>
        <div class="button-confirm" @click="confirmRule()" v-else>确定</div>
      </div>
    </el-dialog>
    <el-dialog
      title="确定修改"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="hintClose">
      <div>
        <div class="hint">确认修改所选的<span>{{checkedUserList.length}}</span>个票务的指派规则？</div>
        <div class="button-ed">
          <div class="button-cancel" @click="dialogVisible = false">取消</div>
          <div class="button-confirm" @click="confirmBatch">确定</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="票务详情"
      :visible.sync="detailShow"
      width="30%"
      :before-close="detailClose">
      <div class="detail">
        <div class="detail-div">
          <div class="detail-div-text">昵称： <span>{{ detailMessage.sellerName }}</span></div>
          <div class="detail-div-text">UUID： <span>{{ detailMessage.sellerUuid }}</span></div>
        </div>
        <div class="detail-div">
          <div class="detail-div-text">状态：
            <span v-if="detailMessage.status == 0">禁用</span>
            <span v-if="detailMessage.status == 1">在线</span>
            <span v-if="detailMessage.status == 2">离线</span>
            <span v-if="detailMessage.status == 3">过期</span>
          </div>
          <div class="detail-div-text">账号到期时间： <span>{{ detailMessage.expirationTime }}</span></div>
        </div>
        <div class="detail-div">
          <div class="detail-div-text">出票订单数： <span>{{ detailMessage.issueNum }}</span></div>
          <div class="detail-div-text">出票成功率： <span>{{ detailMessage.issueRate }}%</span></div>
        </div>
        <div class="detail-div">
          <div class="detail-div-text">指派规则： <span>{{ detailMessage.appointRuleStr}}</span></div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {saasIndex} from "@/javaApi/saasIndex";
const saasM = new saasIndex
import {saasOrder} from "../../../../javaApi/saasOrder";
const saasMorder = new saasOrder()
import {getUserUUID,} from '@/utils/auth'
export default {
  name: "index",
  data() {
    return {
      setShow: false, //添加公众号
      spread: false, //推广链接
      checked: false,
      addOfficial: false,
      list: [],
      dialogVisible: false,
      detailShow:false,
      pageNo:1,
      pageSize:10,
      currentPage:1,
      qrcodeImg:'', // 授权二维码
      rulesList:[], // 规则列表
      detailMessage:{}, // 票务号详情
      checkedRule:false,
      checkedUserList:[],
      selectList:[], // 选中票务的数组
      checkedRuleList:[], // 选中的规则列表
      type:'', // 是否批量设置规则 0不是1是
      sellerUuids:[], // 选中的票商id
      appointIds:[],// 选中的规则id
      idList:[],
      canAuthTicketNum:0,// 可授权次数
      arrRule:'',
      imageList:[],
      reminder:''
    }
  },
  mounted() {
    this.getAuthorizationNum()
    this.getList()
    this.getRules()
    this.getQrcode()
    this.getTicketImg()
    this.webSocket()
  },
  methods: {
    spreadClose() {
      this.setShow = false
    },
    toPay(index,id) {
      this.$router.push({
        path:'/pc/SaasJoin/pay/index',
        query:{
          payStatus:index,
          type:2,
          id:id
        }
      })
    },
    pageChange() {

    },
    hintClose() {
      this.dialogVisible = false
    },
    addClose() {
      this.addOfficial = false
    },
    detailClose(){
      this.detailShow = false
    },
    // 获取列表
    getList(){
      let params = {
        pageNo:this.pageNo,
        pageSize:this.pageSize
      }
      saasM.getTicketList(params).then(res=>{
        console.log(res)
        if(res.data.code == 200){
          this.list = res.data.data.list
          console.log('list',this.list)
        }else{
          this.$Message.error(res.data.info || res.data.message)
        }
      })
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.searchForm.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.searchForm.pageNo = val
      this.getList()
    },
    // 获取授权二维码
    getQrcode(params){
      saasM.ticketQrcode(params).then(res=>{
        console.log(res)
        if(res.data.code == 200){
          this.qrcodeImg = res.data.data
        }else{
          this.$Message.error(res.data.info || res.data.message)
        }
      })
    },
    // 刷新
    refreshQrcode(){
      this.$Message.success('刷新成功')
      let params = {
        sellerUuid:'',
        type:1
      }
      this.getQrcode(params)
    },
    // 获取规则列表
    getRules(){
      let params = {
        pageNo: 1,
        pageSize: 100
      }
      saasMorder.getAssignRules(params).then(res=>{
        if(res.data.code == 200){
          console.log(res)
          this.rulesList = res.data.data.list
          console.log('this.rulesList',this.rulesList)
          for(let index in this.rulesList){
            this.idList.push(this.rulesList[index].id.toString())
            console.log('this.idList',this.idList)
          }
        }else{
          this.$Message.error(res.data.info || res.data.message)
        }
      })
    },
    // 获取票务号详情
    getDetail(id){
      this.detailShow = true
      let params = {
        sellerUuid:id
      }
      saasM.ticketDetail(params).then(res=>{
        if(res.data.code == 200){
          console.log(res)
          this.detailMessage = res.data.data
        }else{
          this.$Message.error(res.data.info || res.data.message)
        }
      })
    },
    // 设置指派规则
    set(type,item){
      this.appointIds = []
      this.sellerUuids = []
      if(type ==1){
        for(let index in this.checkedUserList){
          this.sellerUuids.push(this.list[index].sellerUuid)
        }
        console.log('this.sellerUuids',this.sellerUuids)
      }else {
        this.sellerUuids.push(item.sellerUuid)
        console.log(item)
        let appointRule = item.appointRule.split(',')
        this.checkedRuleList = appointRule
        console.log('this.checkedRuleList',this.checkedRuleList)
      }
      this.type = type
      console.log(this.checkedRuleList)
      // 1是批量0是单个
      if(type == 1){
        if(this.checkedUserList.length == 0){
          this.$Message.error("请先选择票务号")
          return
        }else {
          this.setShow = true
        }
      }else {
        this.setShow = true
      }

    },
    // 选择票务号
    change(e){
      this.checkedUserList = e
    },
    // 选择规则
    changeRule(e){
      this.arrRule = e
      console.log(e)
    },
    // 单个设置指派规则
    confirmRule(){
      for(let index in this.arrRule){
        this.appointIds.push(this.arrRule[index].toString())
      }
      let appointIds = new Set(this.appointIds)
      console.log('appointIds',appointIds)
      let sellerUuids = new Set(this.sellerUuids)
      let params = {
        sellerUuids:sellerUuids,
        appointIds:appointIds
      }
      // 如果是批量则显示批量确定弹窗
      if(this.type){
        this.dialogVisible = true
      }else {
        saasMorder.settingRule(params).then(res=>{
          if(res.data.code == 200){
            console.log(res)
            this.setShow = false
            this.$Message.success('设置成功')
            this.appointIds = []
            this.getList()
          }else{
            this.$Message.error(res.data.info || res.data.message)
          }
        })
      }
    },
    goAddRule(){
      this.$router.push('/pc/SaasJoin/assignRules/index')
    },
    // 绑定票务号
    bindingTicket(type,sellerUuid){
      this.addOfficial = true
      this.reminder = ''
      let params = {}
      // 1是绑定2是换绑
      if(type == 1){
        params = {
          sellerUuid:'',
          type:type
        }
      }else {
        params = {
          sellerUuid:sellerUuid,
          type:type
        }
      }
     this.getQrcode(params)
    },
    // 批量设置指派规则
    confirmBatch(){
      this.appointIds = []
      for(let index in this.arrRule){
        this.appointIds.push(this.arrRule[index].toString())
      }
      let appointIds = new Set(this.appointIds)
      let sellerUuids = new Set(this.sellerUuids)
      console.log('appointIds',appointIds)
      let params = {
        sellerUuids:sellerUuids,
        appointIds:appointIds
      }
      saasMorder.settingRule(params).then(res=>{
        if(res.data.code == 200){
          console.log(res)
          this.setShow = false
          this.dialogVisible = false
          this.$Message.success('设置成功')
          this.checkedUserList = []
          this.appointIds = []
          this.getList()
        }else{
          this.$Message.error(res.data.info || res.data.message)
        }
      })
    },
    // 获取可授权数量
    getAuthorizationNum(){
      saasM.getAuthorizationNum().then(res=>{
        if(res.data.code == 200){
          this.canAuthTicketNum = res.data.data.canAuthTicketNum
          let canAuthTicketNum = this.canAuthTicketNum.toString()
          if(canAuthTicketNum.indexOf('-')!=-1){
            this.canAuthTicketNum = 0
            console.log('this.canAuthTicketNum',this.canAuthTicketNum)
          }
        }else{
          this.$Message.error(res.data.info || res.data.message)
        }
      })
    },
    // 获取票务图片
    getTicketImg(){
      saasM.getTicketImg().then(res=>{
        console.log(res)
        if(res.data.code == 200){
          this.imageList = res.data.data
        }else{
          this.$Message.error(res.data.info || res.data.message)
        }
      })
    },
    webSocket() {
      var that = this
      let webSocket = null;
      let socketOpen = false;
// 发送消息
      let userUUId = localStorage.getItem('userUUID')
      console.log('userUUId',userUUId)
// 初始化websocket
      if ("WebSocket" in window) {
        webSocket = new WebSocket(process.env.VUE_APP_SAAS_MOVIE_WEBSOCKET + 'ws/ticket-order/' + userUUId);
        webSocket.onopen = function () {
          console.log(process.env.VUE_APP_SAAS_MOVIE_WEBSOCKET + 'ws/ticket-order/' + userUUId)
          console.log("连接成功！");
          socketOpen = true
        };
        webSocket.onmessage = function (evt) {
          var received_msg = evt.data;
          console.log("接受消息：" + received_msg);
          let message = JSON.parse(received_msg)
          that.reminder = message.msg
          that.getList()
        };
        webSocket.onclose = function () {
          console.log("连接关闭！");
        };
        webSocket.onerror = function () {
          console.log("连接异常！");
        };
      }
    }
  }
}
</script>

<style scoped lang="less">
.content-message {
  background: #FFFFFF;
  border-radius: 8px;
  padding: 20px;
  min-height: 92%;

  .title {
    font-size: 18px;
    font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #222222;
    line-height: 25px;
  }
  .official {
    @media(max-width:1600px){
      width: 55%;
      margin-right: 40px;
    }
    margin-top: 20px;
    width: 65%;

    .official-top {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .top-button {
        width: 120px;
        height: 36px;
        background: #FF8622;
        border-radius: 2px;
        text-align: center;
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 36px;
        cursor: pointer;
      }

      .top-message {
        width: 143px;
        height: 32px;
        background: #FFFFFF;
        border-radius: 2px;
        border: 1px solid #3D9EFC;
        text-align: center;
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #3D9EFC;
        line-height: 32px;
        cursor: pointer;
      }
    }

    .official-div {
      height: 80px;
      border-radius: 4px;
      border: 1px solid #EEEEEE;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      margin-top: 20px;
      cursor: pointer;

      .message {
        display: flex;
        align-items: center;

        img {
          width: 40px;
          border-radius: 100%;
          height: 40px;
          margin-left: 16px;
        }

        .name {
          font-size: 14px;
          font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
          font-weight: normal;
          color: #222222;
          line-height: 20px;
          margin-left: 10px;
        }
        .status{
          width: 40px;
          height: 20px;
          background: #F1FBF2;
          border-radius: 2px;
          font-size: 12px;
          font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
          font-weight: normal;
          color: #51C456;
          line-height: 20px;
          text-align: center;
          margin-left: 8px;
        }
      }

      .official-add {
        padding: 0 16px;
        height: 32px;
        background: #FFFFFF;
        border-radius: 2px;
        border: 1px solid #FF8622;
        text-align: center;
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #FF8622;
        line-height: 32px;
        cursor: pointer;
        margin-right: 10px;
      }
    }
  }
}

.button {
  display: flex;
  align-items: center;

  .button-look {
    padding: 0 16px;
    height: 32px;
    background: #FFFFFF;
    border-radius: 2px;
    border: 1px solid #EEEEEE;
    text-align: center;
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #666666;
    line-height: 32px;
    margin-right: 20px;
  }
}

.notice-box {
  .auth-title {
    font-size: 20px;
    font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #222222;
    line-height: 27px;
  }

  .auth-tip {

    .part-box {
      display: flex;
      align-items: center;
      margin-top: 10px;

      .part-circle {
        width: 6px;
        height: 6px;
        background: #999999;
        border-radius: 100%;
      }

      .part-content {
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #666666;
        line-height: 20px;
        margin-left: 8px;

        .sync-template {
          color: #FF4F76;
        }
      }
    }
  }

  .qrcode-box {
    margin-top: 30px;
    display: flex;
    align-items: center;
    justify-content: center;

    .qrcode-div {
      border: 1px solid #EEEEEE;
      border-radius: 4px;
      width: 180px;
      padding: 20px;
      text-align: center;

      img {
        width: 140px;
        height: 140px;
        margin-top: 20px;
        object-fit: contain;
      }

      .nickname {
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #222222;
        line-height: 22px;
        text-align: center;
        margin-top: 10px;
      }
    }
  }
}

.set-message {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;

  .add-message-img {

    img {
      width: 140px;
      height: 140px;
    }
  }

  .set-message-item {
    width: 50%;
    display: flex;
    align-items: center;

    .set-message-text {
      width: 190px;
      font-size: 12px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #222222;
      line-height: 17px;
      margin-left: 8px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: left;
    }
  }

  .qrcode-text {
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #666666;
    line-height: 20px;
    margin-top: 16px;
  }

  .qrcode-button {
    width: 76px;
    height: 32px;
    background: #FFFFFF;
    border-radius: 2px;
    border: 1px solid #EEEEEE;
    text-align: center;
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #3D9EFC;
    line-height: 32px;
    margin: auto;
    margin-top: 20px;
  }

}

.button-ed {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 43px;

  .button-cancel {
    width: 76px;
    height: 32px;
    border-radius: 2px;
    border: 1px solid #EEEEEE;
    text-align: center;
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #222222;
    line-height: 32px;
    margin: 0 10px;
    cursor: pointer;
  }

  .button-confirm {
    width: 104px;
    height: 32px;
    background: #FF8622;
    border-radius: 2px;
    text-align: center;
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #ffffff;
    line-height: 32px;
    margin: 0 10px;
    cursor: pointer;
  }
}

.flex {
  display: flex;
  justify-content: space-between;
}

.spread-title {
  font-size: 16px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #222222;
  line-height: 22px;
  margin-bottom: 10px;
}

.spread-button {
  width: 80px;
  height: 28px;
  background: #FFFFFF;
  border-radius: 2px;
  border: 1px solid #EEEEEE;
  margin: auto;
  margin-top: 30px;
  font-size: 12px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #666666;
  line-height: 28px;
  text-align: center;
  cursor: pointer;
}

.add-message {
  text-align: center;

  .add-message-img {
    img {
      width: 140px;
      height: 140px;
    }
  }

  .qrcode-text {
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #666666;
    line-height: 20px;
    margin-top: 16px;
  }

  .qrcode-button {
    width: 76px;
    height: 32px;
    background: #FFFFFF;
    border-radius: 2px;
    border: 1px solid #EEEEEE;
    text-align: center;
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #3D9EFC;
    line-height: 32px;
    margin: auto;
    margin-top: 20px;
  }
}

/deep/ .el-dialog__header {
  border-bottom: 1px solid #e5e5e5;
}

.hint {
  text-align: center;
  font-size: 16px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #222222;
  line-height: 22px;

  span {
    color: #FF4F76;
  }
}
.detail{
  .detail-div{
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .detail-div-text{
      width: 50%;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #999999;
      line-height: 20px;
      span{
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #222222;
        line-height: 20px;
      }
    }
  }
}
/deep/.el-dialog__header{
  border-bottom: 1px solid #e5e5e5;
}
/deep/.el-input__inner:focus{
  border-color: #FF8622!important;
}
/deep/.el-range-editor.is-active, .el-range-editor.is-active:hover{
  border-color: #FF8622!important;
}
/deep/.el-date-table td.today{
  background: #FF8622;
}
/deep/.el-input__inner:hover{
  background: #FCF8F5;
  border-color: #FF8622!important;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active{
  background: #FF8622!important;
}
/deep/.el-checkbox__label{
  display: none;
}
.align-right{
  text-align: right;
  margin-top: 20px;
}
.active{
  color: #FF8622!important;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/SaasJoin/ticketIn/index.vue